import {format, ConfigError, KeywordCase, DataTypeCase} from 'sql-formatter';

export enum SQLLanguages {
    sql = "sql",
    bigquery = "bigquery",
    db2 = "db2",
    db2i = "db2i",
    hive = "hive",
    mariadb = "mariadb",
    mysql = "mysql",
    tidb = "tidb",
    n1ql = "n1ql",
    plsql = "plsql",
    postgresql = "postgresql",
    redshift = "redshift",
    singlestoredb = "singlestoredb",
    snowflake = "snowflake",
    spark = "spark",
    sqlite = "sqlite",
    transactsql = "transactsql",
    trino = "trino"
}

export const statementCaseOptions:{label: string, value: string}[]=[
        {
            label: "Upper",
            value: "upper",
        },
        {
            label: "Lower",
            value: "lower",
        },
        {
            label: "Preserve",
            value: "preserve",
        }
    ]


export const SQLOptions: {label: string, value: SQLLanguages}[] = [
    {
        label: "PostgreSQL",
        value: SQLLanguages.postgresql,
    },
    {
        label: "ANSI SQL",
        value: SQLLanguages.sql,
    },
    {
        label: "Big Query",
        value: SQLLanguages.bigquery,
    },
    {
        label: "DB2",
        value: SQLLanguages.db2,
    },
    {
        label: "DB2i",
        value: SQLLanguages.db2i,
    },
    {
        label: "Hive",
        value: SQLLanguages.hive,
    },
    {
        label: "Maria DB",
        value: SQLLanguages.mariadb,
    },
    {
        label: "MYSQL",
        value: SQLLanguages.mysql,
    },
    {
        label: "TiDB",
        value: SQLLanguages.tidb,
    },
    {
        label: "N1QL",
        value: SQLLanguages.n1ql,
    },
    {
        label: "PL/SQL",
        value: SQLLanguages.plsql,
    },
    {
        label: "Redshift",
        value: SQLLanguages.redshift,
    },
    {
        label: "SingleStore",
        value: SQLLanguages.singlestoredb,
    },
    {
        label: "Snowflake",
        value: SQLLanguages.snowflake,
    },
    {
        label: "Spark",
        value: SQLLanguages.spark,
    },
    {
        label: "SQLite",
        value: SQLLanguages.sqlite,
    },
    {
        label: "Transact-SQL",
        value: SQLLanguages.transactsql,
    },
    {
        label: "Trino",
        value: SQLLanguages.trino,
    }
]

export const formatSQL = (sqlText: string, SQLLanguage: SQLLanguages, keywordCase: KeywordCase, dataTypeCase: DataTypeCase) => {
    return format(sqlText, {language: SQLLanguage, keywordCase: keywordCase, dataTypeCase: dataTypeCase })
}
